import { render, staticRenderFns } from "./SchoolSettings.vue?vue&type=template&id=406ba3d0&scoped=true"
import script from "./SchoolSettings.ts?vue&type=script&lang=ts&external"
export * from "./SchoolSettings.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/School/school.scss?vue&type=style&index=0&id=406ba3d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ba3d0",
  null
  
)

export default component.exports